import type { AnyRouter } from '@tanstack/react-router'

/** Prepare Seaa's custom SSR bootstrap before React hydrates the existing HTML. */
export async function loadRouterForHydration(router: AnyRouter) {
  // TanStack omits its outer Suspense on the server. Its standard hydration
  // helper sets this marker so the client uses the same boundary tree. Seaa
  // supplies its own query/bootstrap payload, so retain that contract here.
  router.ssr ??= { manifest: undefined }
  await router.load()
}
